import { getClientRolesFromRoles } from '../../../mappers/clientRolesMap';
export const getDefaultClientAdminModel = () => ({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    isNew: true
});
export const getDefaultClientFormModel = () => ({
    name: '',
    fiscalIdentifier: '',
    admins: [getDefaultClientAdminModel()],
    noOfCompanies: 0,
    noOfUsers: 0,
    noOfStorageGB: 0,
    roles: [],
    features: []
});
export const getDefaultEditClientFormModel = () => ({
    ...getDefaultClientFormModel(),
    comment: ''
});
export const getEditClientFormModelFromClientDetails = (clientDetails) => {
    var _a, _b;
    return ({
        name: clientDetails.name,
        fiscalIdentifier: clientDetails.fiscalIdentifier,
        noOfCompanies: clientDetails.companies.available,
        noOfUsers: clientDetails.users.available,
        noOfStorageGB: clientDetails.storage.available,
        admins: clientDetails.admins.map(x => ({
            ...x,
            isNew: false
        })),
        features: (_a = clientDetails.features) === null || _a === void 0 ? void 0 : _a.sort(),
        roles: (_b = getClientRolesFromRoles(clientDetails.roles.available)) === null || _b === void 0 ? void 0 : _b.sort(),
        comment: ''
    });
};
export const getDefaultClientsFilterFormModelState = () => ({
    extraFeatures: [],
    status: []
});
